import { Action } from 'redux';
import { IAsynchronouslyLoadedValue, ClaimWithMetadata } from '../types';

export const DETAILED_CLAIM_CLEAR = 'detailedClaim/clear';
export const DETAILED_CLAIM_GET = 'detailedClaim/get';
export const DETAILED_CLAIM_LOADED = 'detailedClaim/loaded';

export interface DetailedClaimGetAction extends Action {
    type: typeof DETAILED_CLAIM_GET;
    payload: IAsynchronouslyLoadedValue<ClaimWithMetadata>;
}

export interface DetailedClaimLoadedAction extends Action {
    type: typeof DETAILED_CLAIM_LOADED;
    payload: IAsynchronouslyLoadedValue<ClaimWithMetadata>;
}

export interface DetailedClaimClearAction extends Action {
    type: typeof DETAILED_CLAIM_CLEAR;
    payload: IAsynchronouslyLoadedValue<ClaimWithMetadata>;
}

export type DetailedClaimActions = DetailedClaimGetAction | DetailedClaimLoadedAction | DetailedClaimClearAction;
